import apiUrl from "../../../../../utils/settings";

export const myAccountUrl = () => {
  return apiUrl + '/users/me';
};
export const updateAccountUrl = () => {
  return apiUrl + '/users/profile';
};
export const deleteProfileImageUrl = () => {
  return apiUrl + '/users/profile-image';
};